import { SxProps } from '@mui/material';
import theme from '../../theme';

export const DISCARD_CONFIRMATION_MESSAGE =
  'You have unsaved changes. Are you sure you want to discard them?';

export const PaperSx: SxProps = {
  position: 'relative',
  backgroundColor: theme.palette.common.white,
  borderRadius: '8px',
  padding: '44px 40px 32px 40px',
  maxHeight: '100vh',
  width: '520px',
};

export const CloseIconSx = {
  position: 'absolute',
  top: '16px',
  right: '20px',
  zIndex: 2,
  '&:hover': {
    cursor: 'pointer',
  },
};
